// extracted by mini-css-extract-plugin
module.exports = {"logo":"ProfileCompany_logo__s6eJH"};